import { Message } from '@messageformat/react';
import { ReactElement } from 'react';
import {
  IconRadar,
  IconResearch,
  IconPartnership,
  IconSolution,
} from '@op/opds.opux-icons/misc';
import { IconStock, IconFunds, IconEtf } from '@op/opds.opux-icons/finance';
import { space } from '@op/opds.tokens';
import TileContent from './TileContent';

interface TileProps {
  answerNumber: string;
}

const TaskTwoTiles = ({ answerNumber }: TileProps): ReactElement => {
  return (
    <div style={{ marginTop: space.large }}>
      {answerNumber === '0' && (
        <div className="investoracademy-vertical-flex-align investoracademy-recommendation-tiles">
          <h5 className="investoracademy-title-paragraph investoracademy-centered-and-padding-default-text">
            <Message id="course5.task2.suitable_tools.titles.self" />
          </h5>
          <div className="investoracademy-recommendation-tile-group">
            <TileContent
              icon={<IconRadar className="investoracademy-task-tile-icon" />}
              msgId="course5.task2.suitable_tools.markets"
            />
            <TileContent
              icon={<IconResearch className="investoracademy-task-tile-icon" />}
              msgId="course5.task2.suitable_tools.equity_analyses"
            />
          </div>
          <h5 className="investoracademy-title-paragraph investoracademy-centered-and-padding-default-text">
            <Message id="course5.task2.investment_options.titles.self" />
          </h5>
          <div className="investoracademy-recommendation-tile-group">
            <TileContent
              icon={<IconStock className="investoracademy-task-tile-icon" />}
              msgId="course5.task2.investment_options.equities"
            />
            <TileContent
              icon={<IconFunds className="investoracademy-task-tile-icon" />}
              msgId="course5.task2.investment_options.funds"
            />
            <TileContent
              icon={<IconEtf className="investoracademy-task-tile-icon" />}
              msgId="course5.task2.investment_options.etf"
            />
          </div>
        </div>
      )}
      {answerNumber === '1' && (
        <div className="investoracademy-vertical-flex-align investoracademy-recommendation-tiles">
          <h5 className="investoracademy-title-paragraph investoracademy-centered-and-padding-default-text">
            <Message id="course5.task2.suitable_tools.titles.easy" />
          </h5>
          <div className="investoracademy-recommendation-tile-group">
            <TileContent
              icon={<IconRadar className="investoracademy-task-tile-icon" />}
              msgId="course5.task2.suitable_tools.funds"
            />
          </div>
          <h5 className="investoracademy-title-paragraph investoracademy-centered-and-padding-default-text">
            <Message id="course5.task2.investment_options.titles.easy" />
          </h5>
          <div className="investoracademy-recommendation-tile-group">
            <TileContent
              icon={<IconFunds className="investoracademy-task-tile-icon" />}
              msgId="course5.task2.investment_options.funds"
            />
            <TileContent
              icon={<IconEtf className="investoracademy-task-tile-icon" />}
              msgId="course5.task2.investment_options.etf"
            />
          </div>
        </div>
      )}
      {answerNumber === '2' && (
        <div className="investoracademy-vertical-flex-align investoracademy-recommendation-tiles">
          <h5 className="investoracademy-title-paragraph investoracademy-centered-and-padding-default-text">
            <Message id="course5.task2.suitable_tools.titles.advice" />
          </h5>
          <div className="investoracademy-recommendation-tile-group">
            <TileContent
              icon={<IconPartnership className="investoracademy-task-tile-icon" />}
              msgId="course5.task2.suitable_tools.advice"
            />
            <TileContent
              icon={<IconSolution className="investoracademy-task-tile-icon" />}
              msgId="course5.task2.suitable_tools.ideas"
            />
          </div>
          <h5 className="investoracademy-title-paragraph investoracademy-centered-and-padding-default-text">
            <Message id="course5.task2.investment_options.titles.advice" />
          </h5>
          <div className="investoracademy-recommendation-tile-group">
            <TileContent
              icon={<IconFunds className="investoracademy-task-tile-icon" />}
              msgId="course5.task2.investment_options.funds"
            />
            <TileContent
              icon={<IconEtf className="investoracademy-task-tile-icon" />}
              msgId="course5.task2.investment_options.equity_etf"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default TaskTwoTiles;
